import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
const ErrorMessageContent = {
  error: /*#__PURE__*/_jsxs(UIErrorMessage, {
    type: "error",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.goneWrong"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.pleaseRefresh"
    })]
  }),
  badRequest: /*#__PURE__*/_jsx(UIErrorMessage, {
    type: "badRequest",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.pleaseRefresh"
    })
  }),
  notFound: /*#__PURE__*/_jsxs(UIErrorMessage, {
    type: "notFound",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.profile.notFound"
      })
    }), /*#__PURE__*/_jsx(UIRouterLink, {
      to: "/",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.goBackHome"
      })
    })]
  }),
  private: /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "team-availability",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.profile.privateProfile"
    }),
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "connectDotCom.profile.searchAndFilter",
      options: {
        linkToDirectory: /*#__PURE__*/_jsx(UIRouterLink, {
          style: {
            whiteSpace: 'nowrap'
          },
          to: "/",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.directoryPage"
          })
        })
      }
    })
  })
};

const ErrorMessage = ({
  type
}) => {
  return ErrorMessageContent[type];
};

export default ErrorMessage;